// extracted by mini-css-extract-plugin
module.exports = {"button":"LoginButton3-module--button--afdy6","scaling":"LoginButton3-module--scaling--3uKhJ"};